import { INoRowsOverlayParams } from 'ag-grid-community';
import { FC } from 'react';
import {
	Button, ButtonAppearance, ButtonColor, Empty, useUrlParams,
} from '@aleph/shared-components';
import { RedditLevel } from 'wb-reddit/src/app/routes/superGrid/utils';
import { useNavigate, useParams } from 'react-router-dom';

const mapTopLevelToItem = {
	[RedditLevel.AD_ACCOUNT]: 'ad accounts',
	[RedditLevel.CAMPAIGN]:   'campaigns',
	[RedditLevel.GROUP]:      'groups',
	[RedditLevel.AD]:         'ads',
};

const NoRowsOverlay: FC<INoRowsOverlayParams> = (params) => {
	const navigate = useNavigate();
	const { setUrlParam } = useUrlParams({ navigate, useParams });

	return (
		<div
			className="flex w-full justify-center flex-col items-center gap-[16px]"
		>
			<div className='flex w-[40px] h-[40px]'>
				<Empty fill="hsl(var(--gray-500))"/>
			</div>
			<div className="!text-[14px] !leading-[17px] !text-gray-500 font-medium">
				There are no
				{` ${mapTopLevelToItem[params.context?.gridTopLevel ?? RedditLevel.AD_ACCOUNT]} `}
				matching these criteria.
			</div>
			<Button
				title="Reset view"
				appearance={ButtonAppearance.OUTLINED}
				color={ButtonColor.GRAY}
				onClick={() => setUrlParam('filters', {})}
			/>
		</div>
	);
};

export default NoRowsOverlay;
